import { ERubric } from '../../../../types/rubricsLinks';

export function rubricToAnalyticsCategory(rubric: ERubric): string {
  switch (rubric) {
    case ERubric.Rent:
      return 'main_rent';
    case ERubric.Sale:
      return 'main_sale';
    case ERubric.ResidentialComplexes:
      return 'main_newobjects';
    case ERubric.Commercial:
      return 'main_commercial';
    case ERubric.Mortgage:
      return 'main_mortgage';
    case ERubric.Countryside:
      return 'main_countryside';
    case ERubric.Services:
    case ERubric.Extra1024:
    case ERubric.Extra1093:
    case ERubric.Extra1242:
    case ERubric.OldExtra1024:
    case ERubric.OldExtra1093:
      return 'main_more';
    default:
      return '';
  }
}
